import React, { Fragment, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Grid, Typography, FormGroup, Tooltip, Collapse } from '@mui/material';

import ThumbDownAltTwoToneIcon from '@mui/icons-material/ThumbDownAltTwoTone';

import ArtistDashboardEventCard from '../events/ArtistDashboardEventCard';
import AnimatedEventCardSlot from './AnimatedEventCardSlot';

import Button from '../layout/SvgButton';

const CanceledArtistEvents = ({
    hostMe,
    myArtistEvents,
    iConfirmed,
    recentlyCanceledIds = [],
    onAnimationComplete,
}) => {
    const [showCanceledEvents, setShowCanceledEvents] = useState(false);

    useEffect(() => {
        if (myArtistEvents && myArtistEvents.length > 0) {
            const unReviewedEvents = myArtistEvents.forEach((myArtistEvent) => {
                if (
                    myArtistEvents.filter(
                        (myEvent) =>
                            myEvent.confirmedHost &&
                            myEvent.status === 'CANCELED'
                    ).length > 0
                ) {
                    setShowCanceledEvents(true);
                }
            });
        }
    }, [myArtistEvents]);

    // Auto-expand the canceled section when a cancellation animation is in
    // progress so the arriving card has somewhere to land.
    useEffect(() => {
        if (recentlyCanceledIds && recentlyCanceledIds.length > 0) {
            setShowCanceledEvents(true);
        }
    }, [recentlyCanceledIds]);

    const dayBeforeYesterday = new Date();
    dayBeforeYesterday.setDate(dayBeforeYesterday.getDate() - 2);

    return (
        <>
            {myArtistEvents &&
                myArtistEvents.length > 0 &&
                myArtistEvents.filter(
                    (myEvent) =>
                        myEvent.confirmedHost && myEvent.status === 'CANCELED'
                ).length > 0 && (
                    <>
                        <Typography
                            onClick={() =>
                                setShowCanceledEvents(!showCanceledEvents)
                            }
                            sx={{
                                color: 'var(--link-color)',
                                cursor: 'pointer',
                                margin: showCanceledEvents
                                    ? '16px 16px 0px 16px'
                                    : '16px 16px 16px 16px',
                                textAlign: 'center',
                                transition: 'margin 0.3s ease-in-out',
                            }}
                        >
                            {showCanceledEvents
                                ? 'Hide Canceled Events'
                                : 'Show Canceled Events'}
                        </Typography>
                        <Collapse in={showCanceledEvents} timeout={300}>
                            <Grid
                                container
                                direction="column"
                                sx={{
                                    marginBottom: '20px',
                                    marginTop: showCanceledEvents
                                        ? '0px'
                                        : '-20px',
                                    transition: 'margin 0.3s ease-in-out',
                                }}
                            >
                                <Grid item>
                                    <Typography
                                        component="h2"
                                        sx={{ color: 'var(--red)!important' }}
                                    >
                                        {myArtistEvents.filter(
                                            (myEvent) =>
                                                myEvent.confirmedHost &&
                                                myEvent.status === 'CANCELED'
                                        ).length > 1
                                            ? `These  ${
                                                  myArtistEvents.filter(
                                                      (myEvent) =>
                                                          myEvent.confirmedHost &&
                                                          myEvent.status ===
                                                              'CANCELED'
                                                  ).length
                                              } concerts got canceled`
                                            : `This concert got canceled`}
                                        :
                                    </Typography>
                                </Grid>
                                {/* {bookingWhenWhere && bookingWhenWhere.length > 0 && bookingWhenWhere[0].when ? //check to be sure there's a valid first entry */}
                                <Grid
                                    container
                                    className="whenBooking"
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={2}
                                    sx={{
                                        margin: '0px auto 16px',
                                        width: '100%',
                                    }}
                                ></Grid>
                                {myArtistEvents
                                    .filter(
                                        (myEvent) =>
                                            myEvent.confirmedHost &&
                                            myEvent.status === 'CANCELED'
                                    )
                                    .sort((a, b) => {
                                        const aTime = new Date(
                                            a?.bookingWhen || 0
                                        ).getTime();
                                        const bTime = new Date(
                                            b?.bookingWhen || 0
                                        ).getTime();
                                        return bTime - aTime; // most recent first
                                    })
                                    .map(
                                        (thisEvent, idx) =>
                                            thisEvent.bookingWhen &&
                                            thisEvent.bookingWhere && (
                                                <AnimatedEventCardSlot
                                                    key={
                                                        (thisEvent &&
                                                            thisEvent._id) ||
                                                        idx
                                                    }
                                                    eventId={thisEvent._id}
                                                    isArriving={recentlyCanceledIds.includes(
                                                        thisEvent._id
                                                    )}
                                                    onAnimationComplete={
                                                        onAnimationComplete
                                                    }
                                                >
                                                    <ArtistDashboardEventCard
                                                        thisEvent={thisEvent}
                                                    />
                                                </AnimatedEventCardSlot>
                                            )
                                    )}
                            </Grid>
                        </Collapse>
                    </>
                )}
        </>
    );
};

CanceledArtistEvents.propTypes = {
    artist: PropTypes.object,
    myArtistEvents: PropTypes.array,
    iConfirmed: PropTypes.func.isRequired,
    recentlyCanceledIds: PropTypes.array,
    onAnimationComplete: PropTypes.func,
};

const mapStateToProps = (state) => ({
    artist: state.artist,
    myArtistEvents: state.event.myArtistEvents,
});

export default connect(mapStateToProps, {})(CanceledArtistEvents);
